module.exports = __webpack_public_path__ + "static/media/stedelijk.70e4f82d.jpg";